module.exports = __webpack_public_path__ + "img/huiyi.c47542b5.png";